export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Generate login URL at runtime so redirect URI reflects the current origin.
export const getLoginUrl = () => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  // SSR/prerender-safe: `window` is undefined during static prerendering. Fall
  // back to an empty origin (the real value is filled in on the client after
  // hydration, which is when login URLs are ever actually used/clicked).
  const origin =
    typeof window !== "undefined" ? window.location.origin : "";
  const redirectUri = `${origin}/api/oauth/callback`;
 const state = btoa(redirectUri);

 const url = new URL(`${oauthPortalUrl}/app-auth`);
 url.searchParams.set("appId", appId);
 url.searchParams.set("redirectUri", redirectUri);
 url.searchParams.set("state", state);
 url.searchParams.set("type", "signIn");

 return url.toString();
};
